import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import HeartIcon from 'assets/like-outline.svg'
import WarningIcon from 'assets/warning.svg'
import NotificationIcon from 'assets/notification.svg'
import DiscountIcon from 'assets/discount.svg'
import ReleaseIcon from 'assets/new-release.svg'
import SaleIcon from 'assets/sell.svg'
import NewsIcon from 'assets/campaign.svg'
import MailIcon from 'assets/mail.svg'

type Props = {
  icon: string
}

// Define a dictionary to map icon names to their respective components
const iconDict: { [key: string]: React.ComponentType } = {
  heartoutline: HeartIcon,
  warning: WarningIcon,
  notification: NotificationIcon,
  discount: DiscountIcon,
  release: ReleaseIcon,
  sale: SaleIcon,
  news: NewsIcon,
  mail: MailIcon
}

export default function IconDisplayer(props: Props) {
  const { icon } = props

  // Get the component from the dictionary based on the icon name,
  // or use a default icon if the icon name is not recognized
  const IconComponent = iconDict[icon] || HeartIcon

  // Define the styled component using the selected component
  const Icon = styled(IconComponent)`
    width: 2em;
    height: 2em;
    margin-right: ${theme.spacing('xs')};
  `

  return (
    <Wrapper>
      <Icon />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`
